import crypto from 'crypto';

const GCM_TAG_SIZE = 16;

export const encryptPayload = (
  plaintext: string,
  key: crypto.CipherKey,
  iv: Buffer,
  authTagLength?: number
): {
  ciphertext: string;
  iv: string;
} => {
  // Create a cipher with AES-GCM mode
  const cipher = crypto.createCipheriv('aes-128-gcm', key, iv, {
    authTagLength: authTagLength || GCM_TAG_SIZE,
  });

  // Encrypt the plaintext
  const encryptedPayload = Buffer.concat([cipher.update(plaintext, 'utf8'), cipher.final()]);

  // Get the authentication tag
  const tag = cipher.getAuthTag();

  return {
    ciphertext: Buffer.concat([encryptedPayload, tag]).toString('hex'),
    iv: iv.toString('hex'),
  };
};

export const decryptPayload = (ciphertext: Buffer, key: crypto.CipherKey, iv: Buffer, authTagLength?: number): string => {
  // Split tag from ciphertext
  const ivBuffer = iv;
  const tag = ciphertext.subarray(ciphertext.length - authTagLength || GCM_TAG_SIZE);
  const enc = ciphertext.subarray(0, ciphertext.length - authTagLength || GCM_TAG_SIZE);
  // Create a cipher with AES-GCM mode
  const decipher = crypto.createDecipheriv('aes-128-gcm', key, ivBuffer);
  decipher.setAuthTag(tag);

  const decryptedPayload = decipher.update(enc) + decipher.final('utf8');

  return decryptedPayload;
};
